import { FC } from 'react';
import { AskBeaCard } from '../../caseload-search/AskBeaCard';

const EXAMPLE_QUESTIONS = [
    'Which clients came back from a decline, and what was recorded around it?',
    'What happened to the clients who had an incident?',
    'Who has gone quiet, with no family observations lately?'
];

/**
 * The ask box on the insights tab, which hands the question to Bea's chat.
 *
 * Deliberately not the caseload page's search: that one puts the question to every client in turn and
 * assembles a verdict per client, which is the right shape for "who has a DNR on file" and the wrong
 * one for "why did that week look like that". A question about the figures on this page is a
 * conversation, so it opens as one. It also keeps this surface off the caseload search's container
 * singleton, which the roster on the clients page filters itself by.
 */
export const InsightsAskBea: FC<{ onAsk: (question: string) => void }> = ({ onAsk }) => (
    <AskBeaCard
        heading="Ask Bea about these numbers"
        blurb="She read the same records these figures come from. Ask about a week, a client, or a figure that looks wrong."
        placeholder="Ask about a figure, a week, or a client"
        examples={EXAMPLE_QUESTIONS}
        onAsk={onAsk}
    />
);
